import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

import { DISPLAY_MODE_BINOM, DISPLAY_MODE_FACEBOOK } from '@/../configs/displayModes';
import CardHeader from '@/components/Includes/CardHeader/CardHeader.vue';
import SelectionColumnsInTable from '@/components/Includes/SelectionColumnsInTable/SelectionColumnsInTable.vue';
import IMultiSelectItem from '@/interfaces/selects/IMultiSelectItem';
import ISelectItemDefault from '@/interfaces/selects/ISelectItemDefault';

@Component({
    name: 'CampaignsListTools',
    components: {
        SelectionColumnsInTable,
        CardHeader
    }
})
export default class CampaignsListTools extends Vue {
    @Prop(Array) private tableColumns!: any;

    private id = '';
    private title = '';
    private campaignId = '';
    
    private selectedLimit: string = '100';
    private selectedTableColumns: IMultiSelectItem[] = [];
    private limits: ISelectItemDefault[] = [
        { value: '100', text: '100' },
        { value: '250', text: '250' },
        { value: '500', text: '500' }
    ];

    private selectedDisplayMode = DISPLAY_MODE_BINOM;

    @Watch('selectedDisplayMode', {immediate: true})
    private onChangeSelectedDisplayMode() {
        this.$emit('change:displayMode', this.selectedDisplayMode)
    }

    @Watch('selectedTableColumns')
    private changedTableColumns(columnsList: IMultiSelectItem[]) {
        this.selectedTableColumns = columnsList
        this.$emit('selectedTableColumns', columnsList);
    }

    @Watch('selectedLimit')
    private changeLimit(){
        this.$emit('limit', this.selectedLimit);
    }

    private onUpdateId(value: string) {
        this.id = value;
        this.$emit('update', 'id', value);
    }

    private onUpdateTitle(value: string) {
        this.title = value;
        this.$emit('update', 'title', value);
    }

    private onUpdateCampaignId(value: string) {
        this.campaignId = value;
        this.$emit('update', 'campaignId', value);
    }
}
